module.exports = __webpack_public_path__ + "static/media/rose.871625a4.png";